/**
 * Created by tudou on 2020/4/11 21:45.
 */
import IIcon from './IIcon.vue';

export default IIcon;
